import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Outlet, useNavigation, useOutletContext } from '@remix-run/react';
export const HeadOutlet = () => _jsx(Outlet, { context: { target: 'head' } });
export const BodyOutlet = () => _jsx(Outlet, { context: { target: 'body' } });
export class AbsRemixPage extends Component {
    constructor() {
        super(...arguments);
        this.HeadContent = () => {
            const { state } = useNavigation();
            const { Head, HeadSkeleton, useRouteLoading } = this;
            const routeLoading = useRouteLoading();
            if (state === 'loading' || routeLoading) {
                return _jsx(HeadSkeleton, {});
            }
            return _jsx(Head, {});
        };
        this.BodyContent = () => {
            const { state } = useNavigation();
            const { Body, BodySkeleton, useRouteLoading } = this;
            const routeLoading = useRouteLoading();
            if (state === 'loading' || routeLoading) {
                return _jsx(BodySkeleton, {});
            }
            return _jsx(Body, {});
        };
        this.Content = () => {
            const { HeadContent, BodyContent } = this;
            const context = useOutletContext();
            if (context.target === 'head') {
                return _jsx(HeadContent, {});
            }
            else {
                return _jsx(BodyContent, {});
            }
        };
    }
    render() {
        const { Content } = this;
        return _jsx(Content, {});
    }
}
